var _path, _g, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4516_186952)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4516_186952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 213,
    height: 213
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213 0H0V213H213V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4516_186952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.305 19.375C154.527 19.375 193.618 58.4662 193.618 106.688C193.618 154.91 154.527 194.001 106.305 194.001C58.0834 194.001 18.9922 154.91 18.9922 106.688C18.9922 58.4662 58.0834 19.375 106.305 19.375Z",
    fill: "#FFC66D"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4516_186952)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4516_186952",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 26,
    width: 162,
    height: 162
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187 26H25V188H187V26Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4516_186952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8312 56.5757L90.3231 57.8926C89.669 61.0874 91.7391 64.1863 94.9339 64.8403C98.099 65.4816 101.206 63.4328 101.86 60.2379L108.888 61.6624C111.73 62.2348 113.541 64.9926 112.982 67.8046L104.684 108.738C102.8 118.021 99.3833 126.926 94.5599 135.082L93.573 136.757C92.4537 138.657 90.2383 139.661 88.0644 139.217L80.7727 137.75C81.4268 134.555 79.3483 131.435 76.1618 130.802C72.9883 130.139 69.8682 132.218 69.2354 135.404L61.1865 133.769C58.851 133.291 57.6566 130.659 58.8827 128.593L59.2672 127.947C64.0821 119.769 67.4984 110.864 69.3833 101.582L77.6805 60.6478C78.2401 57.8358 80.9894 56.0033 83.8312 56.5757Z",
    fill: "#FFDDAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5434 95.0647C76.009 93.1343 77.1424 91.133 79.0728 90.5986C81.0032 90.0642 83.0045 91.1976 83.5389 93.128C84.0734 95.0585 82.9399 97.0597 81.0095 97.5942C79.0791 98.1286 77.0778 96.9951 76.5434 95.0647Z",
    stroke: "#FFC66D",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4457 90.3694C92.9113 88.439 94.0447 86.4377 95.9752 85.9033C97.9056 85.3689 99.9069 86.5023 100.441 88.4327C100.976 90.3632 99.8423 92.3644 97.9118 92.8989C95.9814 93.4333 93.9802 92.2998 93.4457 90.3694Z",
    stroke: "#FFC66D",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8378 82.1594L91.1445 101.328",
    stroke: "#FFC66D",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7159 127.807L64.0078 120.982",
    stroke: "#FFC66D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: "8.44 21.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.635 75.4675L84.0039 71.5801",
    stroke: "#FFC66D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7876 111.282L76.1562 107.395",
    stroke: "#FFC66D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7932 117.376L78.7461 115.279",
    stroke: "#FFC66D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.063 86.1403L157.041 90.5482C154.87 92.9725 155.108 96.6868 157.533 98.8584C159.96 101.007 163.697 100.772 165.846 98.3446L171.236 103.112C173.375 105.011 173.58 108.304 171.677 110.466L143.968 141.731C137.686 148.828 130.265 154.815 122.016 159.459L120.332 160.401C118.395 161.493 115.976 161.243 114.311 159.758L108.759 154.829C110.908 152.401 110.692 148.69 108.245 146.515C105.818 144.366 102.103 144.605 99.9317 147.029L93.7818 141.576C91.9905 140.003 92.3042 137.131 94.3932 135.945L95.0702 135.578C103.32 130.934 110.741 124.947 117.022 117.85L144.709 86.5815C146.635 84.4234 149.925 84.2406 152.063 86.1403Z",
    fill: "#FFF6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.39 116.168C126.883 114.226 128.859 113.051 130.801 113.544C132.742 114.037 133.918 116.013 133.425 117.955C132.932 119.896 130.955 121.072 129.014 120.579C127.072 120.086 125.896 118.109 126.39 116.168Z",
    stroke: "#FFC66D",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.393 120.471C143.886 118.529 145.863 117.353 147.804 117.846C149.746 118.339 150.922 120.316 150.429 122.257C149.936 124.199 147.959 125.375 146.018 124.882C144.076 124.389 142.9 122.412 143.393 120.471Z",
    stroke: "#FFC66D",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.861 109.572L135.965 128.85",
    stroke: "#FFC66D",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.673 154.605L102.652 132.461",
    stroke: "#FFC66D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: "8.44 21.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.764 112.087L144.512 99.4727",
    stroke: "#FFC66D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.19 139.298L119.938 126.684",
    stroke: "#FFC66D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.963 141.619L118.277 134.816",
    stroke: "#FFC66D",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4516_186952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 213,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4516_186952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 162,
    fill: "white",
    transform: "translate(25 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSuccess);
export default __webpack_public_path__ + "static/media/ticket_success.919fcd17fc0163e9162e37a87fa8a52c.svg";
export { ForwardRef as ReactComponent };